require('./preContractualDocumentViewer.scss');

const PropTypes = require('prop-types');
const React = require('react');
const {Component} = require('react');
const {connect} = require('react-redux');
// @core
const { FormattedText, formatText } = require('core/i18n').i18n;
//@helper
const BrowserUtils = require('utilities/browserUtils');
const { recordLink, recordLinkV2 } = require("utilities/tagging");
//@commons
const { OKPdfViewer } = require('commonsComponents/OKPdfViewer');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');
const { LoadingSection } = require('commonsComponents/loadingSection');
//@actions
const pdfActions =  require('actions/mergePreContractualsPDF');
const contractsActions = require('actions/contracts');
//@constants
const { EMPTY_STATE_NOCARD_BANKING } = require('constants/index');
const {
    BUTTON_CLICK,
    DOWNLOAD_ACTION_EVENT,
    PRINT_ACTION_EVENT,
    SCROLL_ACTION_EVENT,
} = require('constants/tagging');
const {
    ScrollableDocument,
  } = require('../../../routes/contractsView/components/documentation/documentsModal/ScrollableDocument');
  const {
    isItWebViewPlatform,
  } = require('../../../routes/migrationUsersBranchView/utilities/migration.utils');

class PreContractualDocumentViewer extends Component {
    constructor(props) {
        super(props);
        this.handlePdfDownload = this.handlePdfDownload.bind(this);
        this.handlePrintPdf = this.handlePrintPdf.bind(this);
        this.handleDocumentReaded = this.handleDocumentReaded.bind(this);
    }

    componentWillUnmount(){
        const { hasPolling, resetPDFMerge } = this.props;
        if (hasPolling){
            resetPDFMerge();
        }
    }

    handlePdfDownload() {
        const { customCategoryEvent, preContractDocumentInfo: { preContractPdfFileName } } = this.props;
        const pdfName = preContractPdfFileName || "documentos";
        this.props.downloadMergedPDF(pdfName);
        recordLink(customCategoryEvent ? customCategoryEvent : window.utag_last_name, BUTTON_CLICK, DOWNLOAD_ACTION_EVENT);
    }

    handlePrintPdf() {
        const { customCategoryEvent, immPdfData } = this.props;
        const pdfFileData = immPdfData.get('mergedPDF');
        const newPdfBlob = new Blob([pdfFileData], {type: "application/pdf"})

        if (BrowserUtils.browserIsIE()) {
            window.navigator.msSaveOrOpenBlob(newPdfBlob);
        } else {
            const blobURL = window.URL.createObjectURL(newPdfBlob);
            const winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,'+
                              'resizable,screenX=50,screenY=50,width=850,height=1050';
            const printWindow = window.open(blobURL, '', winparams);
            printWindow.print();
            recordLink(customCategoryEvent ? customCategoryEvent : window.utag_last_name, BUTTON_CLICK, PRINT_ACTION_EVENT);
        }
    }

    buildErrorComponent(title) {
        const { preContractDocumentInfo: { preContractPdfLink }, requestPDFMerge, pollingPDFMerge, hasPolling, immPreContractualInfo, immPreContractualPolling, retryButtonAnalitycs } = this.props;

        const productsList = immPreContractualInfo.get('products').map(product => product.toJS());

        const handleOnClick = () => {
          if (retryButtonAnalitycs) {
            recordLinkV2(retryButtonAnalitycs);
          }
          if (hasPolling) {
            pollingPDFMerge(immPreContractualPolling.get('operationProcessId'));
          } else {
            requestPDFMerge(preContractPdfLink, productsList);
          }
        };
        const retryButton = (
          <OKButton modifier="secondary" onClick={handleOnClick}>
            <FormattedText value="preContractDocument-preContractDocument_retryButton" />
          </OKButton>
        );

        return (
            <div>
                <div className="precontractual-document-viewer__header">
                    {title}
                </div>
                <EmptyState
                    button={retryButton}
                    primaryText={formatText('preContractDocument-preContractDocument_errorMessage')}
                    iconType={EMPTY_STATE_NOCARD_BANKING}
                    withMargin={true}
                />
                <div className="precontractual-document-viewer__content-err">
                    <FormattedText value="preContractDocument-preContractDocument_pdfErrorMessage" />
                </div>
            </div>
        );
    }

    handleDocumentReaded() {
        const { displayScrollButton, updateConditionDocumentConfirmation, documentReadedCallback } = this.props;

        documentReadedCallback && documentReadedCallback();
        displayScrollButton && updateConditionDocumentConfirmation(true);
    }

    render() {
        const {
            customTitle,
            customCategoryEvent,
            displayScrollButton,
            immContractualPolling,
            immPdfData,
            immPreContractualPolling,
            viewerHeight,
            withoutDownload,
            withoutPrint,
            pdfContainerRef,
            withScrollableDocument,
            handleScroll, 
            isMobile,
        } = this.props;
        const isPdfAvailable = immPdfData.get('mergedPDF');
        const isFetching = immPdfData.get('isFetching') || immPreContractualPolling.getIn(['documents', 'isFetching']) || immContractualPolling.getIn(['documents', 'isFetching']);
        const errorContent = immPdfData.get('errorContent');
        const pdfFile = immPdfData.get('mergedPDF');
        const title = customTitle || <FormattedText value={`preContractDocument-${this.props.titleKey}`} />
        let pdfComponent;
        if(isFetching || (!isPdfAvailable && !errorContent)) {
            return (
                <LoadingSection />
            )
        } else if(isPdfAvailable)  {
            pdfComponent = withScrollableDocument ? (
                <div className="scrollable-document-container" style={{ position: 'relative' }}>
                    <div className="ok-pdf-viewer__header">{title}</div>
                    <div className="scrollable-document-container__icons">
                        {!withoutPrint && <div className="ok-pdf-viewer__action-button">
                            <OKButton
                                onClick={this.handlePrintPdf}
                                modifier="task"
                            >
                                <i className="icon-imprimir" />
                            </OKButton>
                        </div>}
                        {!withoutDownload && (
                            <div className="ok-pdf-viewer__action-button">
                                <OKButton
                                    onClick={this.handlePdfDownload}
                                    modifier="task"
                                >
                                    <i className="icon-descargar" />
                                </OKButton>
                            </div>
                        )}
                    </div>
                  <div className="scrollable-document-container__wrapper">
                    <ScrollableDocument
                        key={isMobile ? 'migration-document-mobile' : 'migration-document'}
                        documentIndex={0}
                        pdfContainerRef={pdfContainerRef}
                        file={pdfFile}
                        onScrollChange={handleScroll}
                    />
                  </div>
                </div>
              ) : (
                <OKPdfViewer
                    displayScrollButton={displayScrollButton}
                    infiniteScroll={!displayScrollButton}
                    onDownload={withoutDownload ? undefined : this.handlePdfDownload}
                    onPrint={withoutPrint ? undefined : this.handlePrintPdf}
                    pdfFile={pdfFile}
                    scale={1.09}
                    title={title}
                    viewerHeight={viewerHeight}
                    hasBorder={true}
                    showScroll={displayScrollButton}
                    onDocumentReaded={this.handleDocumentReaded}
                    scrollButtonAction={() => recordLink(customCategoryEvent ? customCategoryEvent : window.utag_last_name, BUTTON_CLICK, SCROLL_ACTION_EVENT)}
                />
            )
        } else if(errorContent) {
            pdfComponent = this.buildErrorComponent(title);
        }

        return (
            <div className="precontractual-document-viewer__pdf-container">
                {pdfComponent}
            </div>
        );
    }
}

PreContractualDocumentViewer.propTypes = {
    customCategoryEvent: PropTypes.string,
    displayScrollButton: PropTypes.bool,
    documentReadedCallback: PropTypes.func,
    downloadMergedPDF: PropTypes.func,
    hasPolling: PropTypes.bool,
    immPdfData: PropTypes.object,
    immPreContractualInfo: PropTypes.object,
    immContractualPolling: PropTypes.object,
    immPreContractualPolling: PropTypes.object,
    pollingPDFMerge: PropTypes.func,
    preContractDocumentInfo: PropTypes.object.isRequired,
    product: PropTypes.object,
    requestPDFMerge: PropTypes.func,
    resetPDFMerge: PropTypes.func,
    titleKey: PropTypes.string,
    updateConditionDocumentConfirmation: PropTypes.func,
    viewerHeight: PropTypes.number,
    withoutDownload: PropTypes.bool,
    withoutPrint: PropTypes.bool,
}

PreContractualDocumentViewer.defaultProps = {
    customCategoryEvent: '',
    displayScrollButton: false,
    hasPolling: false,
    titleKey: 'preContractDocument_pdfTitle',
    viewerHeight: undefined,
}

module.exports = connect(state => ({
    immPdfData: state.precontractualsMergePdfs,
    immContractualPolling: state.contractualPolling,
    immPreContractualInfo: state.preContractualInfo,
    immPreContractualPolling: state.preContractualPolling,
}),
{
    downloadMergedPDF: pdfActions.downloadMergedPDF,
    pollingPDFMerge: pdfActions.pollingPDFMerge,
    requestPDFMerge: pdfActions.requestPDFMerge,
    resetPDFMerge: pdfActions.resetPDFMerge,
    updateConditionDocumentConfirmation: contractsActions.updateConditionDocumentConfirmation,
}
)(PreContractualDocumentViewer);
